import InsufficientPermissionsPage from 'components/core/InsufficientPermissionsPage/InsufficientPermissionsPage';
import { isManagerOrAdmin } from 'shared/domain/role/isManagerOrAdmin';
import { isStandard } from 'shared/domain/role/isStandard';
import { isViewer } from 'shared/domain/role/isViewer';
import React from 'react';
import { useCurrentUserRole } from 'store/user';
import { MemoCreateCompanyWizardContainer } from 'views/companies/wizard/create/container';
import { MemoEditCompanyWizardContainer } from 'views/companies/wizard/edit/container';
import { MemoGenericRoleAuthorizer } from '../GenericRoleAuthorizer';

export const AuthorizableCreateCompanyWizard = React.memo(
  (): React.ReactElement => {
    const role = useCurrentUserRole();
    const isCurrentUserStandardOrViewer = isStandard(role) || isViewer(role);
    return (
      <MemoGenericRoleAuthorizer
        authorized={isManagerOrAdmin(role)}
        unauthorized={isCurrentUserStandardOrViewer}
        authorizedComponent={MemoCreateCompanyWizardContainer}
        unauthorizedComponent={InsufficientPermissionsPage}
      />
    );
  }
);

export const AuthorizableEditCompanyWizard = React.memo(
  (): React.ReactElement => {
    const role = useCurrentUserRole();
    const isCurrentUserStandardOrViewer = isStandard(role) || isViewer(role);
    return (
      <MemoGenericRoleAuthorizer
        authorized={isManagerOrAdmin(role)}
        unauthorized={isCurrentUserStandardOrViewer}
        authorizedComponent={MemoEditCompanyWizardContainer}
        unauthorizedComponent={InsufficientPermissionsPage}
      />
    );
  }
);
